module.exports = __webpack_public_path__ + "static/img/Frame 1852.649d3a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-live/swiper1/Frame 1852.png
// module id = qxAO
// module chunks = 12